export default __webpack_public_path__ + "static/media/4.35ca0852.png";